<template>
    <div class="w-100">
        <span v-if="loading">Loading ...</span>
        <v-window v-else v-model="activeTab" class="oss-dark">
            <v-window-item value="CONNECTOR" class="oss-dark">
                <v-row class="py-2" style="flex-wrap: nowrap">
                    <v-col cols="8">
                        <v-text-field-filled
                            v-model="search"
                            append-inner-icon="$search"
                            clearable
                            @click:clear="search = ''"
                            label="Rechercher"
                            hide-details
                            class="grow-1"
                        />
                    </v-col>
                    <v-col cols="4">
                        <v-select-filled
                            v-model="filtredType"
                            :items="types"
                            label="Type"
                            hide-details
                            class="shrink-1"
                            density="compact"
                            item-title="text"
                        >
                            <template #item="{ props, item }">
                                <v-divider
                                    v-if="
                                        item.raw.divider ||
                                        (item.raw.props && item.raw.props.divider)
                                    "
                                />
                                <v-list-subheader
                                    v-else-if="
                                        item.raw.header || (item.raw.props && item.raw.props.header)
                                    "
                                    >{{ item.raw.header }}</v-list-subheader
                                >
                                <v-list-item
                                    v-else
                                    v-bind="props"
                                    :value="item.value"
                                    class="text-capitalize"
                                >
                                    <!-- {{ item.title }} -->
                                </v-list-item>
                            </template>
                        </v-select-filled>
                    </v-col>
                </v-row>
                <v-list lines="three">
                    <v-list-item
                        v-for="(c, index) of filteredConnectors"
                        :key="c.id"
                        @click="() => {}"
                    >
                        <template #prepend>
                            <v-avatar size="40">
                                <v-img :src="getLogo(c.application)" width="40" cover />
                            </v-avatar>
                        </template>
                        <v-list-item-title>{{ c.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ getType(c.type) }}</v-list-item-subtitle>

                        <template v-slot:append class="d-flex align-center">
                            <v-btn
                                elevation="0"
                                :disabled="c.active"
                                @click="redirectToConnection(c)"
                            >
                                Ajouter
                            </v-btn>
                        </template>
                    </v-list-item>
                </v-list>
            </v-window-item>
            <v-window-item value="SPECIFICATION" class="oss-dark"></v-window-item>
        </v-window>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import GET_CONNECTORS from "@/graphql/connector/GetConnectors.gql";
import GET_CONSUMER_CONNECTION_URL from "@/graphql/connector/GetConsumerConnectionUrl.gql";
import { OfferAccessRight } from "@/services/accessRightServices";
import { ConnectorServices } from "@/services/connectorServices";
import { Offer_type } from "@/types/offer.types";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class AddConnector extends Vue {
    @Prop({ required: true }) companyId!: string;

    loading = false;
    activeTab = "CONNECTOR";
    filtredType = "ALL";
    collectType = ["INVOICE", "E-COMMERCE", "POINT_OF_SALE"];
    search = "";

    connectorToSpecify = null;

    @Apollo({
        query: GET_CONNECTORS,
        variables() {
            this.loading = true;
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data) {
                    this.connectors = data.getConnectors.connectors;
                    debugger;
                } else {
                    this.connectors = [];
                }
                this.loading = false;
            }
        },
    })
    connectors = [];

    getLogo(application: string) {
        return ConnectorServices.getLogo(application);
    }

    getType(type: string) {
        return ConnectorServices.getType(type);
    }

    get types() {
        const typeTab = [
            {
                text: "Tous",
                value: "ALL",
            },
            {
                divider: true,
            },
            {
                header: "Connecteur",
            },
            {
                text: "Facture",
                value: "INVOICE",
            },
            {
                text: "Facturation",
                value: "INVOICING",
            },
            {
                text: "E-commerce",
                value: "E-COMMERCE",
            },
            {
                text: "Point de vente",
                value: "POINT_OF_SALE",
            },
        ];
        if (this.isAllowedTo) {
            typeTab.push({ divider: true });
            typeTab.push({
                text: "Service",
                value: "COLLECT",
            });
        }
        return typeTab;
    }

    get isAllowedTo() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        return OfferAccessRight.checkOfferAccessRight("isAllowedToConnector", false);
    }

    get offerType() {
        return this.$store.state.offerType;
    }

    get filteredConnectors() {
        let result = [];
        debugger;
        if (this.filtredType === "ALL") {
            if (this.isAllowedTo) {
                result = this.connectors;
            } else {
                const filteredConnections = [];

                for (const connection of this.connectors) {
                    for (const type of this.collectType) {
                        if (connection.type === type) {
                            filteredConnections.push(connection);
                            break;
                        }
                    }
                }
                result = filteredConnections;
            }
        } else {
            result = this.connectors.filter((connection) => connection.type === this.filtredType);
        }

        if (this.search) {
            result = result.filter((connection) =>
                connection.name.toLowerCase().includes(this.search.toLowerCase().trim()),
            );
        }

        return result.sort((a, b) => a.name.localeCompare(b.name));
    }

    async redirectToConnection(c) {
        // if (c?.origin === "BOBBEE" && !c?.externalId) {
        //     this.connectorToSpecify = c;
        //     this.activeTab = "SPECIFICATION";
        //     return;
        // }
        const consumerConnectionUrl = await this.$apollo.query({
            query: GET_CONSUMER_CONNECTION_URL,
            variables: {
                integratorId: `${c?.externalId}` || "",
                companyId: this.companyId,
                origin: c.origin,
                type: c.type,
                application: c.application,
                syncedStartImportDate: c.datePickerFormat,
            },
        });

        if (consumerConnectionUrl) {
            window.location.href = consumerConnectionUrl.data.getConsumerConnectionUrl.url;
        }
    }
}

export default toNative(AddConnector);
</script>
